// Component Uses
import Header from "../Header/Header";
import Reviews from "../Reviews/Reviews";
import ReviewsButton from './../ReviewsButton/ReviewsButton';

const Home = () => {
     return (
          <>
               <Header/>
               <Reviews/>
               <ReviewsButton/>
          </>
     );
};

export default Home;